import axios from 'axios'

export default {

  async ACTION_LOGIN({ commit }, credentials) {},

  async ACTION_LOGOUT({ commit }, logoutData) { },

  async GET_I18N_LOCALE({ commit, state }, querylang) {
    try {
      if (!state.locale) {
        let response = await axios.get('http://localhost:8081/lang?lang=' + state.currentLanguage);
        let locale = response.data
        commit('setLocale', { locale })
      }
    } catch (error) {
      console.error(error);
    }
  },

  SET_LANGUAGE({ commit }, lang) {
    commit('setLanguage', { lang })
  },

  SET_CONTAINER_CLASS({ commit }, routeName) {
    let classValue = null;
    // Set container class name
    switch (routeName) {
      case 'home': classValue = 'dashboard'; break;
    }
    commit('setContainerClass', classValue)
  },

  SET_LAYOUT({ commit }, routeName) {
    let layoutValue = null;
    switch (routeName) {
      case 'dashboard':
      default:
        layoutValue = 'desktop-layout';
        break;
      case 'login':
        layoutValue = 'login-layout';
        break;
      case 'forgot-password':
        layoutValue = 'forgot-password';
        break;
      case 'patient':
        layoutValue = 'desktop-layout';
        break;
        case 'set-password':
        layoutValue = 'update-password-layout';
    }
    commit('setLayout', layoutValue);
  },

  SET_USER_DATA({ commit }, userData) {
    commit('setUserInfo', userData)
  },
  async httpPost({ commit }, options) {
    try {
      let reqParams = {
        method: 'POST',
        url: options.url,
        data: options.data,
        headers: options.headers
      }
      let response = await axios(reqParams)
      if (response && response.data)
        return response.data;
      return null;
    } catch (e) {
      console.log("error in calling http post call", e);
    }
  },
  async dateFormat({ commit }, options) {
    try {
      return moment(options.date).format(options.format)
    } catch (e) {
      return "";
    }
  },
  SET_DASHBOARD_TITLE({ commit }, title) {
    commit('setDashboardTitle', title)
  },
  SET_MENU_DATA({ commit }, data) {
      commit('SET_MENU_DATA', data)
  },
  SET_ACTION_TYPE({ commit }, data) {
      commit('SET_ACTION_TYPE', data)
  },
  SET_MASTER_TYPE({ commit }, type) {
      commit('SET_MASTER_TYPE', type)
  },
  SET_MASTER_TYPE_NAME({ commit }, type) {
      commit('SET_MASTER_TYPE_NAME', type)
  },
  SET_SERVICE_TYPE_NAME({ commit }, type) {
    commit('SET_SERVICE_TYPE_NAME', type)
}
}



// WEBPACK FOOTER //
// ./src/store/actions.js